import ArrayHelper from "../helpers/array-helper";

class MobileNavigation {
    constructor(layoutsContainer) {
        this.consts = {
            subnavIdAttr: 'data-subnav-id',
            desktopNavigationScreenWidth: 967
        };

        this.container = document.getElementsByClassName('layout-nav-mobile-container')[0];

        if (!this.container) {
            console.warn('layout-nav-mobile-container not found. Mobile menu is not loaded');

            return;
        }

        if (!DeviceHelper.isMobilebrowser()
            && screen.width >= this.consts.desktopNavigationScreenWidth
            && screen.height >= this.consts.desktopNavigationScreenWidth) {
            console.log('Desktop device detected. Mobile navigation not loaded.');
            return;
        }

        this.layoutsContainer = layoutsContainer;

        this.init();
    }

    async init() {
        var loadMobileNavigationQuery = document.getElementsByClassName('js-load-mobile-navigation');
        if (loadMobileNavigationQuery.length > 0) {
            this.loadMobileNavigationElement = loadMobileNavigationQuery[0];
        }

        if (await this.loadNavigationFromOtherPage() == false) {
            this.initContainers();
            this.loadHeaders();
            this.loadLinks();
            this.loadAdditionalButtons();
            this.attachEvents();
        }
    }

    async loadNavigationFromOtherPage() {
        if (!this.loadMobileNavigationElement) return false;

        const mobileMenuBtns = document.querySelectorAll('.js-mobile-menu-btn, .btn-search-mobile');

        let isLoaded = false;

        const handleClick = async (btn) => {
            if (isLoaded) return;
            isLoaded = true;

            const navigationData = await LayoutNavigationHelper.getNavigationData(this.loadMobileNavigationElement);
            if (navigationData) {
                document.querySelector('.navWrapper').innerHTML = navigationData;

                this.initContainers();
                this.loadHeaders();
                this.loadLinks();
                this.loadAdditionalButtons();
                this.attachEvents();

                btn.click();
            }
        };

        mobileMenuBtns.forEach(btn => {
            if (!btn.hasAttribute('onclick')) {
                btn.addEventListener('click', () => handleClick(btn), { once: true });
            }
        });

        return mobileMenuBtns.length > 0;
    }


    async getNavigationData() {
        return await fetch(this.loadMobileNavigationElement.getAttribute('data-fetch-url'))
            .then(function (response) {
                return response.text();
            })
            .then(function (response) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(response, 'text/html');
                var navWrapper = doc.getElementsByClassName('navWrapper')[0];
                return navWrapper.innerHTML;
            })
            .catch(function (response) {
                console.log(response.statusText);
            });
    }

    initContainers() {
        this.submenus = new Map();
        this.navigationContainer = this.container.querySelector('ul.layout-nav-mobile');
        this.mainnavContainer = this.container.querySelector('.layout-nav-mobile-level-container.level-one');
        this.submenusContainerLevelTwo = this.container.querySelector('.layout-nav-mobile-level-container.level-two');
        this.submenusContainerLevelThree = this.container.querySelector('.layout-nav-mobile-level-container.level-three');
        this.submenusContainerLevelFour = this.container.querySelector('.layout-nav-mobile-level-container.level-four');
        this.submenusContainerLevelFive = this.container.querySelector('.layout-nav-mobile-level-container.level-five');
        this.submenusContainerLevelSix = this.container.querySelector('.layout-nav-mobile-level-container.level-six');
        this.mobileSearchIcon = this.container.querySelector('.layout-nav-mobile-header .btn-search-mobile');
        this.navigationClickedElements = [];

        this.menuContainers = [
            { container: this.mainnavContainer, class: 'level-one', level: 1, header: null },
            { container: this.submenusContainerLevelTwo, class: 'level-two', level: 2, header: null },
            { container: this.submenusContainerLevelThree, class: 'level-three', level: 3, header: null },
            { container: this.submenusContainerLevelFour, class: 'level-four', level: 4, header: null },
            { container: this.submenusContainerLevelFive, class: 'level-five', level: 5, header: null },
            { container: this.submenusContainerLevelSix, class: 'level-six', level: 6, header: null }

        ];

        this.arrowIcon = IconHelper.getSvgHref('icon-arrow-right');

        this.header = null;
        this.mainnavHeader = null;
        this.submenusHeader = null;
    }

    loadHeaders() {
        this.header = this.container.getElementsByClassName('layout-nav-mobile-header')[0];

        if (!this.header) {
            return;
        }

        // If there is no search wisget in the header remove the search widget container in the mobile menu
        var searchWrapper = document.body.querySelector('.header-one .search-wrapper');

        if (searchWrapper.children && searchWrapper.children.length > 0) {
            DomHelper.addClass('has-search', this.container);
        } else {
            var searchBoxContainer = this.header.getElementsByClassName('layout-nav-mobile-header-search-container')[0];

            if (searchBoxContainer) {
                DomHelper.removeElement(searchBoxContainer);
            }
        }

        var html = this.header.outerHTML;

        this.menuContainers.forEach(menu => {
            menu.container.insertAdjacentHTML('afterbegin', html);
            menu.header = menu.container.firstElementChild;
            DomHelper.addClass('mainnav-header', menu.header);
        });
    }

    loadLinks() {
        this.submenus.clear();

        var layouts = Array.prototype.slice.call(this.layoutsContainer.getElementsByClassName('navItemLayoutMobile'));
        layouts.forEach((layout) => {
            this.loadParentLinks(layout);
        });
    }

    loadParentLinks(layout) {
        var parentAnchor = layout.querySelector('.navParent a');

        if (!parentAnchor) {
            return;
        }

        var parentLink = MobileNavigation.createMenuItemFromAnchor(parentAnchor, this.navigationContainer, ['nav-title']);
        var layoutContent = layout.getElementsByClassName('navDropdown')[0];

        if (!(layoutContent && layoutContent.childNodes && layoutContent.childNodes.length > 0)) {
            return;
        }

        var hasAnchors = layoutContent.getElementsByTagName('a')[0];

        if (!hasAnchors) {
            return;
        }

        var sublayouts = Array.prototype.slice.call(layoutContent.getElementsByClassName('navLevelTwoLayout'));

        if (sublayouts.length > 0) {
            var defaultSubLayoutFound = false;

            sublayouts.forEach((sublayout) => {
                var subAnchor = sublayout.querySelector('.navLevelTwoLink a');

                if (subAnchor) {
                    var submenuItem = MobileNavigation.createMenuItemFromAnchor(subAnchor, this.navigationContainer);

                    if (LayoutNavigationHelper.sublayoutHasContent(sublayout)) {
                        var sublayoutContent = sublayout.getElementsByClassName('navLevelTwoDropdown')[0];
                        this.loadSubmenu(submenuItem, sublayoutContent);
                    }
                } else if (!defaultSubLayoutFound && LayoutNavigationHelper.sublayoutHasContent(sublayout)) {
                    defaultSubLayoutFound = true;
                    var sublayoutContent = sublayout.getElementsByClassName('navLevelTwoDropdown')[0];
                    this.loadSubmenu(parentLink, sublayoutContent);
                }
            });

            return;
        }

        var navLevelTwoLayout = layoutContent.getElementsByClassName('menuLevelTwoLayout')[0];

        if (navLevelTwoLayout) {
            var leftPanel = navLevelTwoLayout.getElementsByClassName('menuLevelTwoLeft')[0];

            if (leftPanel) {
                var leftPanelAnchors = Array.prototype.slice.call(leftPanel.getElementsByTagName('a'));

                leftPanelAnchors.forEach((leftPanelAnchor) => {
                    MobileNavigation.createMenuItemFromAnchor(leftPanelAnchor, this.navigationContainer);
                });
            }

            var rightPanel = navLevelTwoLayout.getElementsByClassName('menuLevelTwoRight')[0];

            this.loadSubmenu(parentLink, rightPanel);

            return;
        }

        this.loadSubmenu(parentLink, layoutContent);
    }

    loadSubmenu(parentLink, sublayout, css = '2-level-link', level = 2) {
        var allAnchors = Array.prototype.slice.call(sublayout.getElementsByClassName(css));

        if (allAnchors.length == 0) {
            return;
        }

        if (this.menuContainers.length <= level - 1) {
            return;
        }

        var currentContainer = this.menuContainers[level - 1];

        this.addArrowIcon(parentLink);
        DomHelper.addClass('has-submmenu', parentLink);
        parentLink.addEventListener('click', (ev) => { ev.preventDefault(); });

        var subnavId = `subnav-${GUIDHelper.get()}`;
        parentLink.setAttribute(this.consts.subnavIdAttr, subnavId);

        var html = `<ul class="layout-nav-mobile-submenu" ${this.consts.subnavIdAttr}="${subnavId}"></ul>`;
        currentContainer.container.insertAdjacentHTML('beforeend', html);
        var submenu = currentContainer.container.lastElementChild;
        submenu.setAttribute(this.consts.subnavIdAttr, subnavId);
        this.submenus.set(subnavId, submenu);

        var navigations = Array.prototype.slice.call(sublayout.getElementsByClassName('nav-vertical-list-' + level));
        var nextLevel = level + 1;
        navigations.forEach((navigation) => {
            var items = Array.prototype.slice.call(navigation.getElementsByClassName(level + '-level-wrapper'));

            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var anchor = item.getElementsByClassName(level + '-level-link')[0];

                if (anchor) {
                    var submenuItem = MobileNavigation.createMenuItemFromAnchor(anchor, submenu);

                    if (i === 0 && DomHelper.hasClass('nav-vertical-list-' + level + '__has-title', navigation)) {
                        DomHelper.addClass('nav-title', submenuItem);
                    }

                    if (DomHelper.hasClass('nav-vertical-list-' + level + '__arrows-big', navigation)) {
                        DomHelper.addClasses(['nav-title', 'submenu-title'], submenuItem);
                    }

                    var nextLevelNavWrapper = anchor.parentNode.getElementsByClassName(nextLevel + '-level-nav')[0];
                    if (nextLevelNavWrapper) {
                        this.loadSubmenu(submenuItem, nextLevelNavWrapper, nextLevel + '-level-link', nextLevel);
                    }
                    ArrayHelper.removeWhere(allAnchors, (arrItem) => arrItem === anchor);
                }
            }
        });

        allAnchors.forEach((anchor) => {
            MobileNavigation.createMenuItemFromAnchor(anchor, submenu, ['nav-title']);
        });
    }

    addArrowIcon(menuItem) {
        var anchor = menuItem.getElementsByTagName('a')[0].parentNode;
        var svgSpan = `<span>${this.arrowIcon}</span>`;
        anchor.insertAdjacentHTML('beforeend', svgSpan);
    }

    loadAdditionalButtons() {
        var footerHtml = '<div class="layout-nav-mobile-footer"></div>';
        this.mainnavContainer.insertAdjacentHTML('beforeend', footerHtml);
        var footer = this.mainnavContainer.lastElementChild;

        var loginLinkWrapper = document.getElementsByClassName('login-link-wrapper')[0];

        if (loginLinkWrapper) {
            var loginLinkWrapperHtml = loginLinkWrapper.innerHTML;

            if (loginLinkWrapperHtml) {
                footer.insertAdjacentHTML('beforeend', loginLinkWrapperHtml);
            }
        }

        var langSelectorWrapper = document.getElementsByClassName('language-selector-wrapper')[0];

        if (langSelectorWrapper) {
            var langSelectorWrapperHtml = langSelectorWrapper.innerHTML;

            if (langSelectorWrapperHtml) {
                footer.insertAdjacentHTML('beforeend', langSelectorWrapperHtml);
            }
        }
    }

    attachEvents() {
        this.header.addEventListener('click', (ev) => {
            let el = DomHelper.getClickTarget(ev);

            do {
                if (el === this.header) {
                    return false;
                } else if (DomHelper.hasClass('btn-mobile-menu', el)) {
                    this.openMobileMenu();

                    return false;
                } else if (DomHelper.hasClass('btn-search-mobile', el) && !el.hasAttribute('onclick')) {
                    this.openMobileMenu();
                    let searchInput = document.querySelector('.nav-one .ui-search input');

                    setTimeout(function () {
                        searchInput.focus();
                    }, 600)

                    return false;
                }
                el = el.parentNode;
            } while (el);
        });

        this.menuContainers.forEach(submenu => {
            submenu.container.addEventListener('click', (ev) => {
                let el = DomHelper.getClickTarget(ev);

                if (el.tagName !== 'A') {
                    do {
                        if (el === this.menuContainers.filter(t => t.level == 1)[0]) {
                            return false;
                        }
                        if (submenu.level == 1) {
                            if (DomHelper.hasClass('btn-close', el)) {
                                this.closeMobileMenu();

                                return false;
                            }
                        }
                        else {
                            var menuIndex = this.menuContainers.indexOf(submenu);

                            if (DomHelper.hasClass('btn-back', el)) {
                                if (submenu.level == 2) {
                                    this.processSubmenus(this.navigationClickedElements.pop(), this.menuContainers[0]);

                                }
                                else {
                                    this.navigationClickedElements.pop()
                                    this.processSubmenus(this.navigationClickedElements[this.navigationClickedElements.length - 1], this.menuContainers[menuIndex - 1]);
                                }
                                return false;
                            } else if (DomHelper.hasClass('btn-close', el)) {
                                this.closeMobileMenu();
                                this.processSubmenus(null, submenu);

                                return false;
                            } else {
                                let menuLink = DomHelper.closest(el, '.has-submmenu', submenu.container);
                                if (menuLink) {
                                    var subNavIdAttr = menuLink.getAttribute(this.consts.subnavIdAttr);
                                    this.navigationClickedElements.push(subNavIdAttr);
                                    this.processSubmenus(subNavIdAttr, this.menuContainers[menuIndex + 1]);
                                    return false;
                                }
                            }
                        }
                        el = el.parentNode;
                    } while (el);
                }
                else {
                    window.location.href = el.getAttribute('href');
                }
            });
        });

        this.navigationContainer.addEventListener('click', (ev) => {
            let el = DomHelper.getClickTarget(ev);
            let menuLink = DomHelper.closest(el, '.has-submmenu', this.navigationContainer);

            if (menuLink && el.tagName !== 'A') {
                var subnavId = menuLink.getAttribute(this.consts.subnavIdAttr);
                this.navigationClickedElements.push(subnavId);
                this.processSubmenus(subnavId, this.menuContainers.filter(t => t.level == 2)[0]);
            }
        });
    }

    openMobileMenu() {
        DomHelper.addClass('open', this.mainnavContainer);
        DomHelper.addClasses(['mobile-nav-open', 'mobile-nav-open__level-one'], document.body);
        this.navigationClickedElements = [];

        setTimeout(() => {
            DomHelper.addClass('mobile-nav-sticky-header', document.body);
        }, 400);
    }

    closeMobileMenu() {
        DomHelper.removeClass('open', this.mainnavContainer);
        DomHelper.removeClass('mobile-nav-sticky-header', document.body);
        this.navigationClickedElements = [];

        setTimeout(() => {
            DomHelper.removeClasses(['mobile-nav-open', 'mobile-nav-open__level-one'], document.body);
        }, 400);
    }

    processSubmenus(openSubmenuId, menu) {
        var hasOpenSubmenu = false;

        this.submenus.forEach((submenu, id, map) => {
            if (openSubmenuId && id == openSubmenuId) {
                DomHelper.addClass('submenu-open', submenu);
                hasOpenSubmenu = true;
            } else {
                DomHelper.removeClass('submenu-open', submenu);
            }
        });

        for (let i = this.menuContainers.indexOf(menu) + 1; i < this.menuContainers.length; i++) {
            DomHelper.removeClass('open', this.menuContainers[i].container);
        }

        if (menu.level <= 2) {
            setTimeout(() => {
                DomHelper.removeClass('mobile-nav-open__level-two', document.body);
            }, 400);
        }

        if (hasOpenSubmenu) {
            DomHelper.addClass('open', menu.container);
            if (menu.level >= 2) {
                DomHelper.addClass('mobile-nav-open__level-two', document.body);
            }
        } else {
            DomHelper.removeClass('open', menu.container);
        }
    }

    static createMenuItemFromAnchor(anchor, menuItemsContainer, cssClasses) {
        var href = anchor.getAttribute('href');
        var target = anchor.getAttribute('target');
        var text = anchor.text;

        var hrefT = !!href ? ` href="${href}"` : ' href="#"';
        var targetT = !!target ? ` target="${target}"` : '';

        var html = `<li><a${hrefT}${targetT}">${text}</a></li>`;
        menuItemsContainer.insertAdjacentHTML('beforeend', html);
        var menuItem = menuItemsContainer.lastElementChild;

        if (cssClasses) {
            cssClasses.forEach((cssClass) => {
                DomHelper.addClass(cssClass, menuItem);
            });
        }

        return menuItem;
    }
}

export default MobileNavigation;